module.exports = __webpack_public_path__ + "img/mobile-clock-wallpaper.fe730b3d.jpg";